import { AngularFireAuth } from "@angular/fire/compat/auth";
import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable, from } from "rxjs";
import { EncryptionService } from './encryption.service';
import type { S3Client } from '@aws-sdk/client-s3';
import { createS3Client, createUpload } from '../../utils/aws-s3.util';

// utils function
import { requestToken } from "../../utils/auth.utils";
import { environment } from "src/environments/environment";
import { AnalyticsService } from './analytics.service';
//declare const AWS: any; // Declare AWS global object to avoid TypeScript errors

@Injectable({
    providedIn: "root",
})

export class UploadService {
    eventData: BehaviorSubject<any> = new BehaviorSubject<any>([]);
    userCurrentTime: any;
    userExpirationTime: any;
    refToken: any;
    encryptedData: any;
    decryptedData: any;
    progressPercentage: any;
    private s3Promise: Promise<S3Client> | null = null;
    setState: any;
    constructor(private http: HttpClient, private afAuth: AngularFireAuth, private encryptionService: EncryptionService, private analytics: AnalyticsService) {
    }

    /** Lazily create (and cache) the S3 client, loading the AWS SDK on demand. */
    private getS3(): Promise<S3Client> {
        if (!this.s3Promise) {
            this.s3Promise = createS3Client({
                region: environment.aws.region,
                credentials: {
                    accessKeyId: environment.aws.accessKeyId,
                    secretAccessKey: environment.aws.secretAccessKey
                }
            });
        }
        return this.s3Promise;
    }

    async uploadFile(userId: any, eventId: any, file: File, platform: any): Promise<any> {
        let fileName = file.name;
        const fileSize = file.size;
        fileName = fileName.replaceAll(' ', '').replace("'", "");
        // console.log(fileName); //__CONSOLE_LOG__

        const params = {
            Bucket: environment.aws.bucketName,
            Key: environment.aws.uploadFolder + "/" + userId + "/events/" + eventId + "/" + fileName,//+"__"+platform,
            Body: file
        };
        const upload = await createUpload({ client: await this.getS3(), params });
        upload.on("httpUploadProgress", (progress) => {
            if (progress.loaded && progress.total) {
                this.progressPercentage = Math.round(progress.loaded / progress.total * 100);
            }
            // console.log(this.progressPercentage); //__CONSOLE_LOG__
        });
        return upload.done();
    }

    async uploadMediaData(eventId: any, md5: any, name: any, image: any, mime_type: any) {

        this.analytics.capture('photo_uploaded', {
            event_id: eventId,
            mime_type: mime_type,
            // Role of the uploader so host-test uploads can be separated from
            // real guest activation. The "1st photo" / "100 photos" milestones
            // are built in PostHog by counting this event per event_id.
            role: localStorage.getItem('isHost') === 'true' ? 'host' : 'guest',
        });

        this.encryptedData = localStorage.getItem('user');
        this.decryptedData = this.encryptionService.decryptData(this.encryptedData);
        const user = JSON.parse(this.decryptedData || "{}");
        // Parse the JSON string
        // const user = JSON.parse(jsonString);
        //  console.log({ user });

        //if (user?.isAnonymous) {
        const token: any = user?.stsTokenManager.accessToken;
        // Add for AccessToken get
        const expirationTime = user?.stsTokenManager.expirationTime;
        const currentTime = new Date().getTime() / 1000;
        this.userCurrentTime = new Date(currentTime * 1000);
        this.userExpirationTime = new Date(expirationTime);
        if (this.userCurrentTime < this.userExpirationTime) {

            const params = new HttpParams()
                .set("event_id", eventId)
                .set("md5", md5)
                .set("image", image)
                .set("mime_type", mime_type)
                .set("name", name);

            // set headers
            const headers = new HttpHeaders()
                .set("Content-Type", "application/x-www-form-urlencoded")
                .set("Authorization", token);

            return this.http.post(
                "https://8e8v8rykh9.execute-api.us-west-1.amazonaws.com/add_media_data",
                params.toString(),
                { headers }
            );
        }
        else {
            // call utils function for token request
            const Reftoken = await requestToken(this.afAuth);
            if (Reftoken) {
                //   console.log(Reftoken);  
                this.refToken = Reftoken;
            }

            const params = new HttpParams()
                .set("event_id", eventId)
                .set("md5", md5)
                .set("image", image)
                .set("mime_type", mime_type)
                .set("name", name);

            // set headers
            const headers = new HttpHeaders()
                .set("Content-Type", "application/x-www-form-urlencoded")
                .set("Authorization", this.refToken);

            return this.http.post(
                "https://8e8v8rykh9.execute-api.us-west-1.amazonaws.com/add_media_data",
                params.toString(),
                { headers });
        }
    }

    async uploadMyFace(base64Image: any, user_name: any, mobile: any, event_id:any) {

        this.encryptedData = localStorage.getItem('user');
        this.decryptedData = this.encryptionService.decryptData(this.encryptedData);
        const user = JSON.parse(this.decryptedData || "{}");
        const token: any = user?.stsTokenManager.accessToken;
        // Add for AccessToken get
        const expirationTime = user?.stsTokenManager.expirationTime;
        const currentTime = new Date().getTime() / 1000;
        this.userCurrentTime = new Date(currentTime * 1000);
        this.userExpirationTime = new Date(expirationTime);
        if (this.userCurrentTime < this.userExpirationTime) {

            const params = new HttpParams()
                .set("image", base64Image)
                .set("user_name", user_name)
                .set("mobile", mobile)
                .set("event_id", event_id.toString());

            // set headers
            const headers = new HttpHeaders()
                .set("Content-Type", "application/x-www-form-urlencoded")
                .set("Authorization", token);

            return this.http.post(
                "https://i23ti4ecvd.execute-api.us-west-1.amazonaws.com/pwa_upload_my_face",
                params.toString(),
                { headers }
            );
        }
        else {
            // call utils function for token request
            const Reftoken = await requestToken(this.afAuth);
            if (Reftoken) {
                //   console.log(Reftoken);  
                this.refToken = Reftoken;
            }

            const params = new HttpParams()
                .set("image", base64Image)
                .set("user_name", user_name)
                .set("mobile", mobile) 
                .set("event_id", event_id.toString());

            // set headers
            const headers = new HttpHeaders()
                .set("Content-Type", "application/x-www-form-urlencoded")
                .set("Authorization", this.refToken);

            return this.http.post(
                "https://i23ti4ecvd.execute-api.us-west-1.amazonaws.com/pwa_upload_my_face",
                params.toString(),
                { headers });
        }
    }

      async uploadMyFaceMyPhotos(base64Image: any, user_name: any, mobile: any, event_id:any) {

        this.encryptedData = localStorage.getItem('user');
        this.decryptedData = this.encryptionService.decryptData(this.encryptedData);
        const user = JSON.parse(this.decryptedData || "{}");
        const token: any = user?.stsTokenManager.accessToken;
        // Add for AccessToken get
        const expirationTime = user?.stsTokenManager.expirationTime;
        const currentTime = new Date().getTime() / 1000;
        this.userCurrentTime = new Date(currentTime * 1000);
        this.userExpirationTime = new Date(expirationTime);
        if (this.userCurrentTime < this.userExpirationTime) {

            const params = new HttpParams()
                .set("image", base64Image)
                .set("user_name", user_name)
                .set("mobile", mobile)
                .set("event_id", event_id.toString());

            // set headers
            const headers = new HttpHeaders()
                .set("Content-Type", "application/x-www-form-urlencoded")
                .set("Authorization", token);

            return this.http.post(
                "https://ynd2weu1z1.execute-api.us-west-1.amazonaws.com/pwa_upload_my_face_myphotos",
                params.toString(),
                { headers }
            );
        }
        else {
            // call utils function for token request
            const Reftoken = await requestToken(this.afAuth);
            if (Reftoken) {
                //   console.log(Reftoken);  
                this.refToken = Reftoken;
            }

            const params = new HttpParams()
                .set("image", base64Image)
                .set("user_name", user_name)
                .set("mobile", mobile) 
                .set("event_id", event_id.toString());

            // set headers
            const headers = new HttpHeaders()
                .set("Content-Type", "application/x-www-form-urlencoded")
                .set("Authorization", this.refToken);

            return this.http.post(
                "https://ynd2weu1z1.execute-api.us-west-1.amazonaws.com/pwa_upload_my_face_myphotos",
                params.toString(),
                { headers });
        }
    }

    uploadLogo(file: File): Observable<any> {
        const params = {
            Bucket: environment.aws.userBucket,
            Key: "public_site_logo" + "/" + localStorage.getItem('u') + "/" + file.name,
            Body: file
            //Bucket: 'picaggo-users',
            // Key: file.name,
            // Body: file,
            // ACL: 'public-read'
        };

        return from(
            (async () => {
                const upload = await createUpload({ client: await this.getS3(), params });
                return upload.done();
            })()
        );
    }
}


